import React from "react";
import Navigation from "../../../components/Navigation";
import EditTutorialForm from "./EditTutorialForm";

const EditTutorial = () => {
  return (
    <div className="bg-[#F7F7F7] calc-h-header">
      <Navigation />

      <EditTutorialForm />
    </div>
  );
};

export default EditTutorial;